import { Moon } from 'lunarphase-js';

export default function moonPhase() {
  let icon: number;
  let title: string;

  const age = Moon.lunarAge();
  const symbol = Moon.lunarPhaseEmoji();

  if (age < 5.53698519483) {
    icon = 1;
    title = 'Jaunatis';
  } else if (age < 12.91963212127) {
    icon = 2;
    title = 'Priešpilnis';
  } else if (age < 20.30227904771) {
    icon = 3;
    title = 'Pilnatis';
  } else if (age < 27.68492597415) {
    icon = 4;
    title = 'Delčia';
  } else {
    icon = 1;
    title = 'Jaunatis';
  }

  return { icon, title, symbol };
}
